import { defineMessages } from 'react-intl';

export default defineMessages({
	already_completed_title: {
		id: 'feedback.already_completed.title',
		defaultMessage: `Thank You For Your Feedback`,
	},
	already_completed_message: {
		id: 'feedback.already_completed.message',
		defaultMessage: `Our records show that you have completed this study. Thank for giving us for your feedback. Please contact your provider for more information.`,
	},
	already_completed_button: {
		id: 'feedback.already_completed.button.text',
		defaultMessage: `Close`,
	},
	already_completed_points_message: {
		id: 'feedback.already_completed_points.message',
		defaultMessage: `Our records show that you have completed this study. You've earned {groupPoints} Study Points for your feedback. It may take up to an hour for your points to be reflected in your account. The creators are very appreciative for your thoughts.`,
	},
	already_completed_points_button: {
		id: 'feedback.already_completed_points.button',
		defaultMessage: `Return to Profile`,
	},

	thank_you_title: {
		id: 'feedback.thank_you.title',
		defaultMessage: `Thank You For Your Feedback`,
	},
	thank_you_message: {
		id: 'feedback.thank_you.message',
		defaultMessage: `You have completed your study. Thanks for giving { publisher } feedback on their video.`,
	},
	thank_you_from_reelchat_message: {
		id: 'feedback.thank_you_from_reelchat.message',
		defaultMessage: `We appreciate you taking time to be with us today, all of your thoughts are highly valued. { partnerName } will reach out in the next couple days to confirm your reward for participation.  Have a great rest of your day.`,
	},
	thank_you_button_redirect: {
		id: 'feedback.thank_you.button.redirect',
		defaultMessage: `Continue`,
	},
	thank_you_button_home: {
		id: 'feedback.thank_you.button.home',
		defaultMessage: `Return Home`,
	},
	thank_you_button_close: {
		id: 'feedback.thank_you.button.close',
		defaultMessage: `Close Window`,
	},
	thank_you_points_message: {
		id: 'feedback.thank_you_points.message',
		defaultMessage: `You've earned { groupPoints } Study Points for your feedback. It may take up to an hour for your points to be reflected in your account. The creators are very appreciative for your thoughts.`,
	},
	thank_you_points_button: {
		id: 'feedback.thank_you_points.button',
		defaultMessage: `Return to Profile`,
	},

	thank_you_waiting_room_title: {
		id: 'feedback.thank_you_waiting_room.title',
		defaultMessage: `Please Wait as You May Be Selected to Discuss Your Thoughts`,
	},
	thank_you_waiting_room_message: {
		id: 'feedback.thank_you_waiting_room.message',
		defaultMessage: `Please wait while we review your responses before we automatically redirect you to a face-to-face discussion via your computer's webcam and microphone. This process may take 5-15 minutes, please hold tight! When you are redirected, your browser will ask you for video and microphone permissions.`,
	},
	thank_you_waiting_room_button_redirect: {
		id: 'feedback.thank_you_waiting_room.button.redirect',
		defaultMessage: `I can't stay for the discussion`,
	},

	dismissed_waiting_room_title: {
		id: 'feedback.dismissed_waiting_room.title',
		defaultMessage: `Our Focus Group Discussion Room Has Been Filled`,
	},
	dismissed_waiting_room_message: {
		id: 'feedback.dismissed_waiting_room.message',
		defaultMessage: `Thank you for waiting to be selected for our focus group selection. We have currently filled our quota for this discussion and you are free to exit. Thank you for participating. The creators are very appreciative for your thoughts.`,
	},
	dismissed_waiting_room_button_redirect: {
		id: 'feedback.dismissed_waiting_room.button.redirect',
		defaultMessage: `Exit`,
	},

	data_quality_title: {
		id: 'feedback.data_quality.title',
		defaultMessage: `Sorry, There Was An Issue With Your Responses`,
	},
	data_quality_from_reelchat_title: {
		id: 'feedback.data_quality_from_reelchat.title',
		defaultMessage: `You Have Been Removed`,
	},
	data_quality_message: {
		id: 'feedback.data_quality.message',
		defaultMessage: `There was an issue with the responses you provided, or your internet connectivity prevented us from getting your feedback.`,
	},
	data_quality_from_reelchat_message: {
		id: 'feedback.data_quality.data_quality_from_reelchat.message',
		defaultMessage: `We had an issue with your participation. Unfortunately this means you cannot continue your participation and you will not receive a reward.`,
	},
	data_quality_button_redirect: {
		id: 'feedback.data_quality.button.redirect',
		defaultMessage: `Continue`,
	},
	data_quality_button_home: {
		id: 'feedback.data_quality.button.home',
		defaultMessage: `Return Home`,
	},
	data_quality_points_message: {
		id: 'feedback.data_quality_points.message',
		defaultMessage: `Unfortunately we aren't able to give you Study Points for your feedback. There was an issue with the responses you provided, or your internet connectivity prevented us from getting your feedback.`,
	},
	data_quality_points_button: {
		id: 'feedback.data_quality_points.button',
		defaultMessage: `Return to Profile`,
	},

	terminate_title: {
		id: 'feedback.terminate.title',
		defaultMessage: `Sorry, You're Not Eligible`,
	},
	terminate_from_reelchat_title: {
		id: 'feedback.terminate_from_reelchat.title',
		defaultMessage: `Sorry, You Have Been Removed`,
	},
	terminate_message: {
		id: 'feedback.terminate.message',
		defaultMessage: `It seems you’re not a fit for this study but we appreciate your interest. Click below to return to your Pilotly profile.`,
	},
	terminate_from_reelchat_message: {
		id: 'feedback.terminate_from_reelchat.message',
		defaultMessage: `We had an issue with your participation, likely technical. Unfortunately this means you cannot continue your participation and you will not receive a reward this time around.`
	},
	terminate_button: {
		id: 'feedback.terminate.button',
		defaultMessage: `Return to Profile`,
	},
	terminate_button_redirect: {
		id: 'feedback.terminate.button.redirect',
		defaultMessage: `Continue`,
	},
	terminate_partner_message: {
		id: 'feedback.terminate_partner.message',
		defaultMessage: `Unfortunately, you have been terminated from this screening. Feel free to enjoy another screening in our portal.`,
	},
	terminate_partner_button: {
		id: 'feedback.terminate_partner.button',
		defaultMessage: `Finish`,
	},
	terminate_distribution_message: {
		id: 'feedback.terminate_distribution.message',
		defaultMessage: `It seems you’re not a fit for this study but we appreciate your interest. { publisher } will reach out with additional details on your reward and next steps.`,
	},
	terminate_distribution_button: {
		id: 'feedback.terminate_distribution.button',
		defaultMessage: `Finish`,
	},

	ineligible_title: {
		id: 'feedback.ineligible.title',
		defaultMessage: `Sorry, You're Not Eligible`,
	},
	ineligible_message: {
		id: 'feedback.ineligible.message',
		defaultMessage: `Unfortunately, you don't fit the qualification to continue with this screening. Feel free to enjoy another screening in our portal.`,
	},
	ineligible_button: {
		id: 'feedback.ineligible.button',
		defaultMessage: `Return to Profile`,
	},
	ineligible_partner_button: {
		id: 'feedback.ineligible_partner.button',
		defaultMessage: `Finish`,
	},
	ineligible_distribution_button: {
		id: 'feedback.ineligible_distribution.button',
		defaultMessage: `Finish`,
	},

	studyreentry_partner_button: {
		id: 'feedback.studyreentry_partner_button',
		defaultMessage: `Finish`,
	},
	studyreentry_distribution_button: {
		id: 'feedback.studyreentry_distribution_button',
		defaultMessage: `Finish`,
	},
	studyreentry_button: {
		id: 'feedback.studyreentry_button',
		defaultMessage: `Return to Profile`
	},
	studyreentry_title: {
		id: 'feedback.studyreentry_title',
		defaultMessage: `Sorry, You've Already Entered Before`
	},
	studyreentry_message: {
		id: 'feedback.studyreentry_message',
		defaultMessage: `For security purposes, we do not allow people to repeatedly enter video studies.  Sorry for the inconvenience.`
	},

	overquota_title: {
		id: 'feedback.overquota.title',
		defaultMessage: `We’re a Little Full Right Now`,
	},
	overquota_message: {
		id: 'feedback.overquota.message',
		defaultMessage: `Sorry we have already received enough viewers for this study. Click below to return to your Pilotly profile, maybe there is something else to watch!`,
	},
	overquota_button: {
		id: 'feedback.overquota.button',
		defaultMessage: `Return to Profile`,
	},
	overquota_partner_message: {
		id: 'feedback.overquota_partner.message',
		defaultMessage: `Sorry we have already received enough viewers for this study. Feel free to join our community and earn rewards for giving feedback on videos.`,
	},
	overquota_partner_button: {
		id: 'feedback.overquota_partner.button',
		defaultMessage: `Finish`,
	},

	notfound_title: {
		id: 'feedback.notfound.title',
		defaultMessage: `Study is Not Found`,
	},
	notfound_message: {
		id: 'feedback.notfound.message',
		defaultMessage: `Feel free to enjoy another screening in our portal.`,
	},
	notfound_button: {
		id: 'feedback.notfound.button',
		defaultMessage: `Return Home`,
	},

	invalid_url_title: {
		id: 'feedback.invalid_url.title',
		defaultMessage: `How Did You Get Here?`,
	},
	invalid_url_message: {
		id: 'feedback.invalid_url.message',
		defaultMessage: `You’ve arrived through an invalid web url. Let’s go back to your Pilotly profile, maybe you can find what you’re looking for there.`,
	},
	invalid_url_distribution_message: {
		id: 'feedback.invalid_url_distribution.message',
		defaultMessage: `You’ve arrived through an invalid web url. Please check your link and try again.`,
	},
	invalid_url_button: {
		id: 'feedback.invalid_url.button',
		defaultMessage: `Return to Profile`,
	},

	invalid_email_title: {
		id: 'feedback.invalid_email.title',
		defaultMessage: `Sorry, You're Not Eligible`,
	},
	invalid_email_message: {
		id: 'feedback.invalid_email.message',
		defaultMessage: `Feel free to enjoy another screening in our portal.`,
	},
	invalid_email_button: {
		id: 'feedback.invalid_email.button',
		defaultMessage: `Return Home`,
	},

	study_closed_title: {
		id: 'feedback.study_closed.title',
		defaultMessage: `This Study is Now Closed`,
	},
	study_closed_message: {
		id: 'feedback.study_closed.message',
		defaultMessage: `Sorry we have already received enough viewers for this group. Click below to return to your Pilotly profile, maybe there is something else to watch!`,
	},
	study_closed_button: {
		id: 'feedback.study_closed.button.text',
		defaultMessage: `Return to Profile`,
	},
	study_closed_partner_message: {
		id: 'feedback.study_closed_partner.message',
		defaultMessage: `Sorry we have already received enough viewers for this study. You can exit this experience by clicking below.`,
	},
	study_closed_partner_button: {
		id: 'feedback.study_closed_partner.button',
		defaultMessage: `Exit`,
	},
	study_closed_distribution_message: {
		id: 'feedback.study_closed_distribution.message',
		defaultMessage: `Sorry we have already received enough viewers for this study. Feel free to join our community and earn rewards for giving feedback on videos.`,
	},
	study_closed_distribution_button: {
		id: 'feedback.study_closed_distribution.button',
		defaultMessage: `Exit to Profile`,
	},

	study_not_started_title: {
		id: 'feedback.study_not_started.title',
		defaultMessage: `This Study is Not Ready`,
	},
	study_not_started_message: {
		id: 'feedback.study_not_started.message',
		defaultMessage: `Sorry, this study is not ready. Please try this link on { startDate } when the study is ready to be viewed.`,
	},
	study_not_started_button: {
		id: 'feedback.study_not_started.button.text',
		defaultMessage: `Return to Profile`,
	},
	study_not_started_partner_button: {
		id: 'feedback.study_not_started_partner.button',
		defaultMessage: `Exit`,
	},
	study_not_started_distribution_button: {
		id: 'feedback.study_not_started_distribution.button',
		defaultMessage: `Exit to Profile`,
	},

	study_paused_title: {
		id: 'feedback.study_paused.title',
		defaultMessage: `We’re Taking a Quick Break`,
	},
	study_paused_message: {
		id: 'feedback.study_paused.message',
		defaultMessage: `Sorry, right now this study is on hold. Please try this link later today, the creator may open access again.`,
	},
	study_paused_button: {
		id: 'feedback.study_paused.button.text',
		defaultMessage: `Return to Profile`,
	},
	study_paused_partner_message: {
		id: 'feedback.study_paused_partner.message',
		defaultMessage: `Sorry, right now this study is on hold. Please try this link later today, the creator may open access again.`,
	},
	study_paused_distribution_message: {
		id: 'feedback.study_paused_distribution.message',
		defaultMessage: `Sorry, right now this study is on hold. Please try this link later today or tomorrow, the creator may open access again.`,
	},

	error_title: {
		id: 'feedback.error.title',
		defaultMessage: `Something Bad Happened`,
	},
	error_message: {
		id: 'feedback.error.message',
		defaultMessage: `We're sorry, an error has occurred. Click below to reload the page or try the link again later today.`,
	},
	error_button: {
		id: 'feedback.error.button',
		defaultMessage: `Reload`,
	},
	error_metadata_failed: {
		id: 'feedback.error.metadata',
		defaultMessage: `Error in updating viewer metadata`
	},
	error_loading_user: {
		id: 'feedback.error.loading_user',
		defaultMessage: `Error in getting updated current user`
	},

	badurl_title: {
		id: 'feedback.badurl.title',
		defaultMessage: `You’ve arrived through an invalid web url. Please check your link and try again.`,
	},
	badurl_message: {
		id: 'feedback.badurl.message',
		defaultMessage: `We're sorry, an error has occurred. Click below to reload the page or try the link again later today.`,
	},
	badurl_button: {
		id: 'feedback.badurl.button',
		defaultMessage: `Reload`,
	},
	invalid_desktop_browser_message: {
		id: 'feedback.invalid_desktop_browser.message',
		defaultMessage: `Please enter the link again using Google Chrome or Safari`,
	},
	invalid_desktop_browser_title: {
		id: 'feedback.invalid_desktop_browser.title',
		defaultMessage: `{browserName} not supported`,
	},
	invalid_device_detected_desktop: {
		id: 'feedback.invalid_device_detected.desktop',
		defaultMessage: `desktop`
	},
	invalid_device_detected_laptop: {
		id: 'feedback.invalid_device_detected.laptop',
		defaultMessage: `laptop`
	},
	invalid_device_detected_message: {
		id: 'feedback.invalid_device_detected.message',
		defaultMessage: `This study cannot be taken on a {deviceType}. Please try the link again on the following devices where it is available:`,
	},
	invalid_device_detected_mobile_phone: {
		id: 'feedback.invalid_device_detected.mobile_phone',
		defaultMessage: `mobile phone`
	},
	invalid_device_detected_tablet: {
		id: 'feedback.invalid_device_detected.tablet',
		defaultMessage: `tablet`
	},
	invalid_device_detected_title: {
		id: 'feedback.invalid_device_detected.title',
		defaultMessage: `{deviceType} detected`,
	},
	invalid_mobile_browser_button: {
		id: 'feedback.invalid_mobile_browser.button',
		defaultMessage: 'Open On {validBrowser}'
	},
	invalid_mobile_browser_message: {
		id: 'feedback.invalid_mobile_browser.message',
		defaultMessage: 'This study requires {browser} web browser to function properly. Your current browser is not compatible with the technology we use. Please click the button below to access on {validBrowser}:',
	},
	invalid_mobile_browser_title: {
		id: 'feedback.invalid_mobile_browser.title',
		defaultMessage: `{validBrowser} Required`,
	},
	invalid_mobile_browser_android_subtitle1: {
		id: 'feedback.invalid_mobile_browser_android.subtitle1',
		defaultMessage: `The above button will open the study directly if Chrome is installed.`,
	},
	invalid_mobile_browser_android_subtitle2: {
		id: 'feedback.invalid_mobile_browser_android.subtitle2',
		defaultMessage: `If Chrome isn't installed, you'll be directed to the Google Play Store. Download it, then return and click the button again.`,
	},
	invalid_mobile_browser_ios_subtitle: {
		id: 'feedback.invalid_mobile_browser_ios.subtitle',
		defaultMessage: `The above button will open the study directly on Safari.`,
	},
	redirect_google_play_dialog_message: {
		id: 'feedback.redirect_google_play_dialog.message',
		defaultMessage: `You will now be redirected to Google Play to install Google Chrome. Once it is installed, please come back to this page and click the button again to access the study on Google Chrome.`
	},
	redirect_google_play_dialog_title: {
		id: 'feedback.redirect_google_play_dialog.title',
		defaultMessage: `Installing Google Chrome`
	}
});



// WEBPACK FOOTER //
// ./src/locales/feedback.js